import React, { useState, useEffect, Suspense } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import AuthImage from '../../Visuals/Images/Authentication.jpg';
import Auth from '../../Helpers/auth';
import UserHomeDataProvider from '../../Utils/Users/UserHomeDataProvider';
import {
  AuthContainer,
  PictureSide,
  AuthenticationSide,
  AuthContainer2,
} from '../../Authentication/AuthStyles.styles';
const PrimaryButton = React.lazy(
  () => import('../../Components/Buttons/PrimaryButton/PrimaryButton.component')
);
const PasswordInput = React.lazy(
  () => import('../../Components/Form/PasswordInput')
);
import { httpSubcontractorLogin } from '../../Hooks/subcontractor/subcontractor.hooks';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
// Form for login
const SubcontractorLoginComponent = () => {
  const navigate = useNavigate();
  const [showPass, setShowPass] = useState(false);
  const [formState, setFormState] = useState({
    pin: '',
  });
  const [error, setError] = useState('');
  const [selectedCompanyId, setSelectedCompanyId] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState({
      ...formState,
      [name]: value,
    });
    if (error.length) {
      setError('');
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (formState.pin.length < 4) {
      setError('Pin is not valid');
      return;
    }
    setIsSubmitting(true);
    const response = await httpSubcontractorLogin({
      pin: formState?.pin,
      companyId: selectedCompanyId,
      userId: Auth.getProfile().data.id,
    });
    const data = await response.json();

    if (response.ok) {
      sessionStorage.setItem('subcontractorAccess', true);
      sessionStorage.setItem('subcontractorCompanyId', selectedCompanyId);
      setFormState({
        pin: '',
        selectedCompanyId: '',
      });
    } else {
      setError(data.msg);
      return;
    }
  };

  useEffect(() => {
    if (isSubmitting && Auth.getToken() !== null) {
      navigate('/subcontractor');
    }
  });

  return (
    <AuthContainer>
      <HelmetHelper title="Contractor Login" description="Contractor Login" />
      <AuthContainer2>
        <PictureSide>
          <img src={AuthImage} loading="eager" alt="Yellow Helmets" />
        </PictureSide>
        <AuthenticationSide>
          <form onSubmit={handleFormSubmit}>
            <h2>Subcontractor Login</h2>
            <UserHomeDataProvider showLoading={false}>
              {(user) => {
                // console.log('User', user);
                return (
                  <>
                    <label htmlFor="company">Select Company</label>
                    <select
                      value={selectedCompanyId}
                      onChange={(e) => setSelectedCompanyId(e.target.value)}
                    >
                      <option value="">Select a company</option>
                      {user?.subcontractorCompanies?.map((company) => (
                        <option
                          key={company?.companyId}
                          value={company?.companyId}
                        >
                          {company?.companyName}
                        </option>
                      ))}
                    </select>
                  </>
                );
              }}
            </UserHomeDataProvider>
            {/* Password */}
            <Suspense fallback={<div>Loading password input...</div>}>
              <PasswordInput
                label="Company Code"
                // span="Must be at least 6 characters"
                handleChange={(e) => {
                  e.preventDefault();
                  setShowPass((prev) => !prev);
                }}
                showPass={showPass}
                code={true}
                value={formState.password}
                name="password"
                onChange={handleChange}
              />
            </Suspense>
            {error && <p className="error">{error}</p>}
            <Suspense fallback={<div>Loading button...</div>}>
              <PrimaryButton span="Login" />
            </Suspense>
          </form>
        </AuthenticationSide>
      </AuthContainer2>
    </AuthContainer>
  );
};

SubcontractorLoginComponent.propTypes = {
  setPage: PropTypes.func,
};

export default SubcontractorLoginComponent;
